import { useState, useCallback } from "react";
import useScheduledDate from "./useScheduledDate";

// Hook to centralize state and logic for share flow from calendar
export const useShareModalFlow = () => {
  const { scheduledDate, setScheduledDate, clearScheduledDate } =
    useScheduledDate();

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingData, setEditingData] = useState(null);

  const openShareModalFromCalendar = useCallback(
    (date) => {
      setScheduledDate(date);
      setCurrentItem(null);
      setIsEditing(false);
      setEditingData(null);
      setIsShareModalOpen(true);
    },
    [setScheduledDate]
  );

  const openShareModalForEdit = useCallback(
    (editingPayload, date) => {
      setScheduledDate(date);
      setCurrentItem(editingPayload.item || null);
      setIsEditing(true);
      setEditingData(editingPayload);
      setIsShareModalOpen(true);
    },
    [setScheduledDate]
  );

  const openShareModalWithItem = useCallback(
    (item, date = null) => {
      if (date) {
        setScheduledDate(date);
      }
      setCurrentItem(item);
      setIsEditing(false);
      setEditingData(null);
      setIsShareModalOpen(true);
    },
    [setScheduledDate]
  );

  const openGalleryFromShareModal = useCallback(() => {
    setIsGalleryOpen(true);
  }, []);

  const selectContentFromGallery = useCallback((selectedItems) => {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];
      setCurrentItem({
        url: selectedItem.url,
        mediaData: selectedItem.mediaData || {},
      });
      setIsGalleryOpen(false);
    }
  }, []);

  const closeGallery = useCallback(() => {
    setIsGalleryOpen(false);
  }, []);

  const closeShareModal = useCallback(() => {
    setIsShareModalOpen(false);
    setIsGalleryOpen(false);
    setCurrentItem(null);
    setIsEditing(false);
    setEditingData(null);
    clearScheduledDate();
  }, [clearScheduledDate]);

  return {
    isShareModalOpen,
    isGalleryOpen,
    currentItem,
    scheduledDate,
    isEditing,
    editingData,
    openShareModalFromCalendar,
    openShareModalForEdit,
    openShareModalWithItem,
    openGalleryFromShareModal,
    selectContentFromGallery,
    closeGallery,
    closeShareModal,
    setCurrentItem,
    setIsEditing,
    setEditingData,
  };
};
